import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Icon from "@mdi/react";
import { mdiLoading, mdiMagnify, mdiTrashCanOutline } from "@mdi/js";

import DateRangePicker from "@wojtekmaj/react-daterange-picker";

const SubscriptionInvoiceSearch = (props) => {
   const filterList = [
      { id: 0, label: "N°", code: "number", type: "text", col: "number" },
      { id: 0, label: "Statut", code: "type", type: "text", col: "status" },
      { id: 0, label: "Date", code: "created", type: "date", col: "created" },
      {
         id: 0,
         label: "Montant",
         code: "total",
         type: "number",
         col: "total",
      },
   ];
   const [loading, setLoading] = useState();
   const [filter, setFilter] = useState(filterList[0]);
   const [searchCritter, setSearchCritter] = useState("");
   const [dateSearch, setOnDateSearch] = useState([new Date(), new Date()]);

   useEffect(() => {
      handleCleanSearch();
   }, [filter]);

   const handleSearch = (e) => {
      setSearchCritter(e.target.value);
      props.onSearch(e.target.value, filter);
   };

   const handleCleanSearch = () => {
      setSearchCritter("");
      props.onSearch(null, filter);
   };

   const handleselectSearch = (i) => {
      setFilter(filterList[i]);
   };

   const handleSpecialSearch = () => {
      if (filter.type === "date") {
         props.onSearch(dateSearch, filter);
      }
   };

   return (
      <div className="d-flex flex-column py-2 align-items-center w-75">
         <div className={"d-flex flex-row justify-content-center align-items-center w-100"}>
            <div
               className={"d-flex flex-row w-100 rounded-lg justify-content-between align-items-center"}
               style={{ backgroundColor: "#f9f9f9", maxWidth: "450px" }}
            >
               {loading ? (
                  <Icon className={"p-1"} path={mdiLoading} spin={true} size={1.2} color={"var(--theme-primary)"} />
               ) : searchCritter ? (
                  <div className={"p-1 px-2 rounded-lg ue-filter-search-btn"} onClick={handleCleanSearch}>
                     <Icon path={mdiTrashCanOutline} size={1} color={"#82858f"} />
                  </div>
               ) : (
                  <div className={"p-1 px-2 rounded-lg ue-filter-search-btn"} onClick={handleSpecialSearch}>
                     <Icon path={mdiMagnify} size={1.2} color={"#82858f"} />
                  </div>
               )}
               {filter?.type === "date" ? (
                  <DateRangePicker onChange={setOnDateSearch} value={dateSearch} />
               ) : (
                  <input
                     id={"ueDocSearchInput"}
                     className="form-control form-control border-0 "
                     style={{ backgroundColor: "unset" }}
                     type="text"
                     placeholder={"N° Facture"}
                     value={searchCritter}
                     onChange={handleSearch}
                  />
               )}
            </div>
            <div className={"border-left border-gray-300 mx-1"}> </div>
            <div className={"ue-filter-dropdown"}>
               <div className={" px-2 rounded-lg "}>
                  <svg
                     width="24"
                     height="24"
                     className={"p-1"}
                     viewBox="0 0 17 17"
                     fill="#8A9397"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M8.5 16.4688C6.92393 16.4688 5.38326 16.0014 4.0728 15.1258C2.76235 14.2502 1.74097 13.0056 1.13784 11.5495C0.534703 10.0934 0.376895 8.49116 0.684371 6.94538C0.991847 5.39959 1.7508 3.9797 2.86525 2.86525C3.9797 1.7508 5.39959 0.991847 6.94538 0.684371C8.49116 0.376895 10.0934 0.534703 11.5495 1.13784C13.0056 1.74097 14.2502 2.76235 15.1258 4.0728C16.0014 5.38326 16.4688 6.92393 16.4688 8.5C16.4688 10.6134 15.6292 12.6403 14.1348 14.1348C12.6403 15.6292 10.6134 16.4688 8.5 16.4688ZM8.5 1.59375C7.13408 1.59375 5.79882 1.9988 4.6631 2.75767C3.52737 3.51654 2.64218 4.59514 2.11946 5.8571C1.59674 7.11905 1.45998 8.50767 1.72646 9.84735C1.99293 11.187 2.65069 12.4176 3.61655 13.3835C4.5824 14.3493 5.81298 15.0071 7.15266 15.2736C8.49234 15.54 9.88096 15.4033 11.1429 14.8805C12.4049 14.3578 13.4835 13.4726 14.2423 12.3369C15.0012 11.2012 15.4063 9.86593 15.4063 8.5C15.4063 6.66835 14.6786 4.91172 13.3835 3.61655C12.0883 2.32137 10.3317 1.59375 8.5 1.59375Z"
                        fill="#8A9397"
                     />
                     <path
                        d="M11.1562 9.03125H5.84375C5.70285 9.03125 5.56773 8.97528 5.4681 8.87565C5.36847 8.77602 5.3125 8.6409 5.3125 8.5C5.3125 8.3591 5.36847 8.22398 5.4681 8.12435C5.56773 8.02472 5.70285 7.96875 5.84375 7.96875H11.1562C11.2971 7.96875 11.4323 8.02472 11.5319 8.12435C11.6315 8.22398 11.6875 8.3591 11.6875 8.5C11.6875 8.6409 11.6315 8.77602 11.5319 8.87565C11.4323 8.97528 11.2971 9.03125 11.1562 9.03125Z"
                        fill="#8A9397"
                     />
                     <path
                        d="M11.1562 6.375H5.84375C5.70285 6.375 5.56773 6.31903 5.4681 6.2194C5.36847 6.11977 5.3125 5.98465 5.3125 5.84375C5.3125 5.70285 5.36847 5.56773 5.4681 5.4681C5.56773 5.36847 5.70285 5.3125 5.84375 5.3125H11.1562C11.2971 5.3125 11.4323 5.36847 11.5319 5.4681C11.6315 5.56773 11.6875 5.70285 11.6875 5.84375C11.6875 5.98465 11.6315 6.11977 11.5319 6.2194C11.4323 6.31903 11.2971 6.375 11.1562 6.375Z"
                        fill="#8A9397"
                     />
                     <path
                        d="M11.1562 11.6875H5.84375C5.70285 11.6875 5.56773 11.6315 5.4681 11.5319C5.36847 11.4323 5.3125 11.2971 5.3125 11.1562C5.3125 11.0154 5.36847 10.8802 5.4681 10.7806C5.56773 10.681 5.70285 10.625 5.84375 10.625H11.1562C11.2971 10.625 11.4323 10.681 11.5319 10.7806C11.6315 10.8802 11.6875 11.0154 11.6875 11.1562C11.6875 11.2971 11.6315 11.4323 11.5319 11.5319C11.4323 11.6315 11.2971 11.6875 11.1562 11.6875Z"
                        fill="#8A9397"
                     />
                  </svg>

                  <span>Filtres</span>
               </div>
               <div className={"ue-filter-dropdown-content"}>
                  {filterList.map((item, index) => {
                     return (
                        <a
                           key={index}
                           className={"ue-table-filter-menu-list-item"}
                           href={"#"}
                           onClick={(e) => handleselectSearch(index)}
                        >
                           {item.label}
                        </a>
                     );
                  })}
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      idUser: state.MeReducer.id,
      entity: state.MeReducer.entity,
      filterForms: state.DashboardReducer.filterForm,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      setIgnKey: (e) => dispatch({ type: "SET_IGN_API_KEY", data: e }),
      setCurrentEntity: (e) =>
         dispatch({
            type: "SET_CURRENT_ENTITY",
            data: { currentEntity: e },
         }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(SubscriptionInvoiceSearch);
